/**
 * Personstamm API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonStammMasterId } from './personStammMasterId';
import { FieldMetaData } from './fieldMetaData';
import { FremdId } from './fremdId';
import { CapiPersonId } from './capiPersonId';
import { PersonStammVersionDetailEntryMeta } from './personStammVersionDetailEntryMeta';
import { PersonAdresseListEntryMeta } from './personAdresseListEntryMeta';


export interface PersonStammMasterDetailEntryMeta { 
    adressen?: Array<PersonAdresseListEntryMeta>;
    mAdressen?: FieldMetaData;
    version?: PersonStammVersionDetailEntryMeta;
    mVersion?: FieldMetaData;
    printRTFpossible?: boolean;
    mPrintRTFpossible?: FieldMetaData;
    kantPersonId?: FremdId;
    mKantPersonId?: FieldMetaData;
    datenquelle?: string;
    mDatenquelle?: FieldMetaData;
    masterId: PersonStammMasterId;
    mMasterId?: FieldMetaData;
    auskunftsperre?: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum;
    mAuskunftsperre?: FieldMetaData;
    capiPersonId?: CapiPersonId;
    mCapiPersonId?: FieldMetaData;
    printPDFpossible?: boolean;
    mPrintPDFpossible?: FieldMetaData;
    egbpid?: string;
    mEgbpid?: FieldMetaData;
}
export namespace PersonStammMasterDetailEntryMeta {
    export type AuskunftsperreEnum = 'AUSKUNFT_SPERRE' | 'ADRESS_SPERRE' | 'KEINE';
    export const AuskunftsperreEnum = {
        AUSKUNFT_SPERRE: 'AUSKUNFT_SPERRE' as AuskunftsperreEnum,
        ADRESS_SPERRE: 'ADRESS_SPERRE' as AuskunftsperreEnum,
        KEINE: 'KEINE' as AuskunftsperreEnum
    };
}


